module.exports = __webpack_public_path__ + "img/16.0c59e752.png";